import React from 'react';
import img from '../images/secondpage.svg';

const Intro = () => {
    const values = [
        { title: "Integrity", desc: "Upholding the highest moral and ethical standards in all our financial dealings." },
        { title: "Excellence", desc: "Striving for superior quality and precision in every project and service we deliver." },
        { title: "Client-Centricity", desc: "Placing our clients' goals and growth at the core of our business strategies." }
    ];

    return (
        <div className="bg-slate-50/50 py-12 md:py-16" id="intro">
            <div className="container mx-auto px-6 max-w-7xl">
                <div className="flex flex-col lg:flex-row items-center gap-12" data-aos="fade-up">
                    
                    {/* Left Column - Graphic/Image */}
                    <div className="w-full lg:w-1/2 flex justify-center">
                        <div className="relative w-full max-w-md">
                            <div className="absolute inset-0 bg-gradient-to-tr from-cyan-500/5 to-indigo-500/5 rounded-3xl filter blur-2xl -z-10"></div>
                            <img 
                                alt="Financial innovation graphic" 
                                className="w-full h-auto object-contain rounded-2xl shadow-xl hover:-translate-y-1 transition-transform duration-500" 
                                src={img} 
                            />
                        </div>
                    </div>

                    {/* Right Column - Text & Core Values */}
                    <div className="w-full lg:w-1/2" data-aos="zoom-in" data-aos-delay="200">
                        <span className="text-sm font-semibold tracking-wider uppercase text-cyan-600 mb-2 block">
                            Who We Are
                        </span>
                        <h3 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-6 leading-tight">
                            Established in 2024, leading the way in innovative financial solutions for the corporate sector.
                        </h3>
                        <p className="text-slate-600 leading-relaxed text-base mb-8">
                            Our mission is to foster business growth through tailored financial services, underpinned by our core values of integrity, excellence, and client-centricity. We invest heavily in research and development to enhance our service offerings and deliver even greater value.
                        </p>
                        
                        {/* Core Values Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            {values.map((val, idx) => (
                                <div key={idx} className="bg-white p-5 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
                                    <h4 className="font-bold text-slate-800 mb-2 text-sm md:text-base">
                                        {val.title}
                                    </h4>
                                    <p className="text-slate-500 text-xs leading-relaxed">
                                        {val.desc}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Intro;
